import React from 'react'
import { TickIcon } from '@mote/assets/icons'
import { useMediaQuery } from '@mote/helpers'
import { FreeTierPricingSection } from './pricing-sections/FreeTierPricingSection'
import { SchoolsTierPricingSection } from './pricing-sections/SchoolsTierPricingSection'
import { UnlimitedTierPricingSection } from './pricing-sections/UnlimitedTierPricingSection'
import {
  Bold,
  CompareCell1,
  CompareCell2,
  CompareCell3,
  CompareCell4,
  CompareGrid,
  Text,
  Title
} from './styles.compare.products.jsx'

function prepareContent(products) {
  return [
    [
      <Title>What do I get</Title>,
      <Title>Free</Title>,
      <Title>Unlimited</Title>,
      <Title>Schools</Title>
    ],
    [
      <Text>
        <Bold>Create voice notes within:</Bold>
        <br />
        Any webpage! <br />
        Google Classroom <br />
        Google Slides <br />
        Google Docs <br />
        Google Sheets <br />
        Google Forms <br />
        Gmail
      </Text>,
      <TickIcon />,
      <TickIcon />,
      <TickIcon />
    ],
    [
      <Text>Recording time</Text>,
      <Text>30 seconds</Text>,
      <Text>180 seconds</Text>,
      <Text>180 seconds</Text>
    ],
    [
      <Text>Unlimited recordings</Text>,
      <Text>(20 per month)</Text>,
      <TickIcon />,
      <TickIcon />
    ],
    [
      <Text>Voice to text transcription</Text>,
      <span />,
      <TickIcon />,
      <TickIcon />
    ],
    [
      <Text>Translate your mote transcripts</Text>,
      <span />,
      <TickIcon />,
      <TickIcon />
    ],
    [
      <Text>Save and reuse motes with motebook</Text>,
      <span />,
      <TickIcon />,
      <TickIcon />
    ],
    [
      <Text>Manage users &amp; view usage</Text>,
      <span />,
      <span />,
      <TickIcon />
    ],
    [<Text>Domain enablement</Text>, <span />, <span />, <TickIcon />],
    [
      <Text>Dedicated support, custom PD</Text>,
      <span />,
      <span />,
      <TickIcon />
    ],
    [
      <></>,
      <FreeTierPricingSection products={products} />,
      <UnlimitedTierPricingSection products={products} />,
      <SchoolsTierPricingSection />
    ]
  ]
}

export const CompareProducts = ({ products }) => {
  const mediaBreakPoint = useMediaQuery([640, 992])
  const content = React.useMemo(() => {
    return prepareContent(products)
  }, [products])

  const isNarrow = mediaBreakPoint === 640

  // console.log('Am I narrow? ', isNarrow)
  return (
    <CompareGrid>
      {content.map((row, index1) => {
        if (isNarrow && content.length - 1 === index1) return null

        return (
          <React.Fragment key={index1}>
            {row.map((cell, index2) => {
              const hideFirstCell = isNarrow && index1 === 0 && index2 === 0
              const compositeIndex = `${index1}/${index2}`
              const isVertical = isNarrow && index1 === 0
              return (
                <React.Fragment key={compositeIndex + 'parent'}>
                  {index2 === 0 && (
                    <CompareCell1 key={compositeIndex}>
                      {hideFirstCell && <span />}
                      {!hideFirstCell && cell}
                    </CompareCell1>
                  )}
                  {index2 === 1 && (
                    <CompareCell2 key={compositeIndex} isVertical={isVertical}>
                      {cell}
                    </CompareCell2>
                  )}
                  {index2 === 2 && (
                    <CompareCell3 key={compositeIndex} isVertical={isVertical}>
                      {cell}
                    </CompareCell3>
                  )}
                  {index2 === 3 && (
                    <CompareCell4 key={compositeIndex} isVertical={isVertical}>
                      {cell}
                    </CompareCell4>
                  )}
                </React.Fragment>
              )
            })}
          </React.Fragment>
        )
      })}
    </CompareGrid>
  )
}
